import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:
 */
import Immutable from 'immutable';
import WorkflowRecord from '../../records/WorkflowRecord';
import WorkflowDetails from '../../records/WorkflowDetails';
import WorkflowViewRecord from '../../records/WorkflowViewRecord';
import { WORKFLOW_INITIALIZE, WORKFLOW_SHOW_VIEW, WORKFLOW_CHECKPOINT, WORKFLOW_CLEAN, WORKFLOW_SET_IGNORE_NEXT_PATH_CHANGE, WORKFLOW_UPDATE_VIEW_FOR_PATH } from './actions';

var workflowReducer = function workflowReducer() {
  var workflow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new WorkflowRecord();
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case WORKFLOW_INITIALIZE:
      {
        var viewKey = action.viewName + '.' + action.viewIndex;
        var details = new WorkflowDetails({
          workflowName: action.name,
          view: action.viewName,
          viewKey: viewKey,
          active: true,
          navigationIndex: 1,
          navigationForward: true,
          ignoreNextPathChange: false,
          pushFirstView: action.pushFirstView,
          views: Immutable.List().push(new WorkflowViewRecord({
            viewKey: viewKey,
            viewName: action.viewName,
            viewIndex: 1
          }))
        });
        return workflow.merge({
          details: details,
          pathnameBeforeWorkflow: action.pathnameBeforeWorkflow
        });
      }

    case WORKFLOW_SHOW_VIEW:
      {
        var viewName = action.viewName;
        var navigationIndex = workflow.details.navigationIndex + 1;
        var viewIndex = workflow.details.views.size + 1;

        var _viewKey = viewName + '.' + viewIndex;

        var _details = workflow.details.merge({
          view: viewName,
          viewKey: _viewKey,
          navigationIndex: navigationIndex + 1,
          navigationForward: true,
          ignoreNextPathChange: true,
          views: workflow.details.views.push(new WorkflowViewRecord({
            viewKey: _viewKey,
            viewName: viewName,
            viewIndex: viewIndex + 1
          })),
          visited: workflow.details.visited.add([viewName, viewIndex, navigationIndex].join('.'))
        });

        return workflow.merge({
          details: _details
        });
      }

    case WORKFLOW_UPDATE_VIEW_FOR_PATH:
      {
        var _viewName = action.viewName,
            _viewIndex = action.viewIndex;

        var _details2 = workflow.details.merge({
          view: _viewName,
          viewKey: "".concat(_viewName, ".").concat(_viewIndex),
          navigationForward: false,
          ignoreNextPathChange: false,
          views: workflow.details.views.take(_viewIndex)
        });

        return workflow.merge({
          details: _details2
        });
      }

    case WORKFLOW_SET_IGNORE_NEXT_PATH_CHANGE:
      {
        var _details3 = workflow.details.merge({
          ignoreNextPathChange: action.ignoreNextPathChange
        });

        return workflow.merge({
          details: _details3
        });
      }

    case WORKFLOW_CHECKPOINT:
      {
        var viewCount = workflow.details.views.size;
        return workflow.merge({
          details: workflow.details.merge({
            views: workflow.details.views.map(function (view, index) {
              return view.merge({
                checkpointed: index < viewCount - 1
              });
            })
          })
        });
      }

    case WORKFLOW_CLEAN:
      return workflow.merge({
        details: new WorkflowRecord()
      });

    default:
      return workflow;
  }
};

export default workflowReducer;